import { useFormikContext } from "formik";
import { Label } from "@/components/base/Label.tsx";
import { Error } from "@/components/base/Error.tsx";
import { SwitchProps } from "@radix-ui/react-switch";
import { Switch } from "@/components/base/Switch.tsx";

interface FormikSwitchProps extends SwitchProps {
  name: string;
  label?: string;
}

export const FormikSwitch = (props: FormikSwitchProps) => {
  const { setFieldValue, errors, touched } = useFormikContext();
  const { label } = props;
  return (
    <div className="flex flex-col gap-2">
      {label && <Label htmlFor={props.id}>{label}</Label>}
      <div className="flex flex-row justify-start gap-4 items-center">
        <Label>Disabled</Label>
        <Switch
          {...props}
          onCheckedChange={(value) => setFieldValue(props.name, value)}
        />
        <Label>Enabled</Label>
      </div>
      {touched[props.name as keyof typeof touched] &&
      errors[props.name as keyof typeof errors] ? (
        <Error error={errors[props.name as keyof typeof errors]} />
      ) : null}
    </div>
  );
};
